<template>
  <div style="background: #f0f2f7">
    <Top />
    <div class="home main">
      <h1>“国研视点”数据库介绍</h1>
      <h2>一、产品内容</h2>
      <p>“国研视点”数据库汇集国务院发展研究中心百余位国家级经济学专家的公开研究成果或观点、国研网特约稿件及访谈稿件，全面展示国务院发展研究中心专家对国民经济、社会发展和改革开放中的全局性、战略性、前瞻性、长期性以及热点、难点问题的研判及对策建议。
</p>
      <span>本数据库所收录内容具体涉及：</span>
      <ul>
        <li>中国宏观经济形势分析及政策建议；</li>
        <li>中长期发展战略和区域经济发展政策；</li>
        <li>产业经济发展、调整方向和产业政策选择；</li>
        <li>中国对外开放的新情况、新问题及政策建议；</li>
        <li>农业和农村经济、社会管理及城乡统筹发展问题；</li>
        <li>企业改革和发展的重大问题及政策建议；</li>
        <li>国民经济和社会发展中的人力资源开发、收入分配与社会保障政策；</li>
        <li>自然资源的合理开发与利用、生态平衡与环境保护政策等。</li>
      </ul>

      <h2>二、产品架构</h2>
      <p>
       “国研视点”数据库充分考虑用户使用体验，采用科学合理的内容架构进行展示，设置了
        <strong>研究报告、专家视点、专家专栏、特别专题、可视化</strong>五个一级栏目，同时从研究领域角度进行了二次分类，以便于用户快速定位和查找相关信息。具体说明如下：
      </p>
      <span style="display:block; text-align:center;font-weight:700;">数据库内容架构及说明</span>
      <table width="100%" cellspacing="1" cellpadding="0" align="center" style="background: #ccc">
        <tbody>
          <tr>
            <td width="110" align="center" bgcolor="#EAEAEA">
              <strong>栏目类型</strong>
            </td>
            <td width="110" align="center" bgcolor="#EAEAEA">
              <strong>栏目名称</strong>
            </td>
            <td align="center" bgcolor="#EAEAEA">
              <strong>内容说明</strong>
            </td>
          </tr>
          <!-- <tr>
            <td align="center" bgcolor="#FFFFFF"></td>
            <td align="center" bgcolor="#FFFFFF">
              <strong>调研报告</strong>
            </td>
            <td
              bgcolor="#FFFFFF"
            >收录1985年以来国务院发展研究中心围绕国家发展的中长期战略问题和经济社会发展的重点热点问题，深入开展调查研究，形成的高质量《调查研究报告》内容。</td>
          </tr> -->

          <tr>
            <td rowspan="5" align="center" bgcolor="#FFFFFF">
              <strong>一级栏目</strong>
            </td>
            <td align="center" bgcolor="#FFFFFF">
              <strong>研究报告</strong>
            </td>
            <td bgcolor="#FFFFFF">主要收录国务院发展研究中心专家在公开媒体上发表的有关经济社会改革和发展热点重点问题的分析文章、对国研网的投稿以及国研网特约稿件。</td>
          </tr>
          <tr>
            <td align="center" bgcolor="#FFFFFF">
              <strong>专家视点</strong>
            </td>
            <td bgcolor="#FFFFFF">主要收录国务院发展研究中心接受媒体包括国研网采访稿、在会议论坛的演讲稿、在公开媒体上发表的观点等。</td>
          </tr>
          <tr>
            <td align="center" bgcolor="#FFFFFF">
              <strong>专家专栏</strong>
            </td>
            <td bgcolor="#FFFFFF">为中心专家特别开设的专栏，围绕特定主题，集中展现专家对于该主题的持续研究成果。</td>
          </tr>
          <tr>
            <td align="center" bgcolor="#FFFFFF">
              <strong>特别专题</strong>
            </td>
            <td bgcolor="#FFFFFF">收录中心专家编写的改革相关系列跟踪与点评报告等内容。</td>
          </tr>
          <tr>
            <td align="center" bgcolor="#FFFFFF">
              <strong>可视化</strong>
            </td>
            <td bgcolor="#FFFFFF">以可视化的方式直观展示专家学术圈、研究领域、发文趋势、发文渠道等信息。</td>
          </tr>

          <tr>
            <td align="center" bgcolor="#FFFFFF">
              <strong>辅助分类</strong>
            </td>
            <td align="center" bgcolor="#FFFFFF">
              <strong>研究领域</strong>
            </td>
            <td bgcolor="#FFFFFF">宏观经济、区域经济、农村经济、产业经济、创新发展、对外经济、社会发展、市场经济、企业研究、金融研究、资源环境、公共管理</td>
          </tr>
          <!-- <tr>
            <td colspan="2" align="center" bgcolor="#FFFFFF">
              <strong>分类2</strong>
              <br />内容性质
            </td>
            <td bgcolor="#FFFFFF">理论分析、热点追踪、行业观察、形势判断、政策探讨</td>
          </tr> -->
        </tbody>
      </table>

      <h2>三、产品特点</h2>
      <ul style="list-style:none;margin-left:5px;">
          <li><strong>权威性。</strong> 国务院发展研究中心是为党中央国务院提供政策咨询服务的重要机构，是首批国家高端智库建设试点单位之一，其研究成果具有很高的权威性。</li>
          <!-- <li><strong>权威性。</strong> 国务院发展研究中心是国务院直属单位，是为党中央国务院提供政策咨询服务的重要机构，是首批国家高端智库建设试点单位之一，其研究成果具有很高的权威性。</li> -->
          <li><strong>前瞻性。</strong> 聚焦国民经济，社会发展和改革开放中的全局性，战略性，前瞻性，长期性以及热点，难点问题，为国家重大发展战略决策提供参考，其研究成果具有高度的前瞻性。</li>
          <!-- <li><strong>前瞻性。</strong> 国务院发展研究中心的研究聚焦国民经济、社会发展和改革开放中的全局性、战略性、前瞻性、长期性以及热点、难点问题，为国家重大发展战略决策提供参考，其研究成果具有高度的前瞻性。</li> -->
          <li><strong>深入性。</strong> 长期坚持从实际问题出发，注重对国民经济和社会发展重大问题的深入研究分析，强调提供客观，准确和科学的分析建议，其研究成果具有很强的深入性。</li>
          <!-- <li><strong>深入性。</strong> 国务院发展研究中心长期坚持从实际问题出发，注重对国民经济和社会发展重大问题的深入研究分析，强调提供客观、准确和科学的分析建议，其研究成果具有很强的深入性。</li> -->
          <li><strong>全面性。</strong> 全面系统地跟踪收录国务院发展研究中心公开成果，内容覆盖宏观经济、区域经济、农村经济、产业经济、创新发展、对外经济、社会发展、市场经济、企业研究、金融研究、资源环境、公共管理等多个领域。</li>
          <!-- <li><strong>全面性。</strong> 全面系统地跟踪收录国务院发展研究中心公开成果，内容覆盖宏观经济、区域经济、农村经济、产业经济、创新发展、对外经济、社会发展、市场经济、企业研究、金融研究、资源环境、公共管理等多个领域。</li> -->
      </ul>

      <h2>四、产品价值</h2>
      <span style="margin-left:5px;">本数据库荟萃经济社会政策研究的权威学术成果，可以帮助用户：</span>
      <ul style="margin-left:25px;">
          <li>科学研判国内外宏观经济形势及未来走势；</li>
          <li>获得权威的国家政策解读及前瞻性的政策动向信息；</li>
          <li>深刻认识经济社会发展重点、热点问题；</li>
          <li>透视海内外经济建设成功经验与教训；</li>
          <li>学习借鉴科学的研究思路、方法和研判视角；</li>
          <li>提高研究决策水平。</li>
      </ul>
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/Top";
import Footer from "@/components/Footer";
export default {
  components: {
    Top,
    Footer
  },
  data() {
    return {};
  }
};
</script>

<style lang='less' scoped>
.main {
  background: #fff;
  padding: 10px 45px 30px 45px;
  margin-top: 20px;
  h1 {
    text-align: center;
    text-indent: 2em;
    font-size: 24px;
    line-height: 60px;
    margin-top: 30px;
  }
  h2 {
    font-size: 18px;
    line-height: 50px;
    margin-top: 20px;
  }
  p {
    text-indent: 2em;
    font-size: 16px;
    line-height: 24px;
  }
  span {
    margin-left: 40px;
    font-size: 16px;
    line-height: 60px;
    display: inline-block;
  }
  ul {
    margin-left: 60px;
    list-style: disc;
    li {
      line-height: 40px;
      font-size: 16px;
    }
  }
  td {
    padding: 10px;
  }
}
</style>